import {
  createEmptySliceBase,
  injectDetailSlice,
  injectTableSlice,
  toReducer
} from '../sliceFactory';

const createAssignSolverReducer = () => {
  const sliceBase = createEmptySliceBase({ name: 'assignSolver' });
  const withTable = injectTableSlice({ sliceBase: sliceBase });
  const withDetail = injectDetailSlice({ sliceBase: withTable });
  return toReducer(withDetail);
};

export default createAssignSolverReducer;
